import {
  submissionsService,
  type SubmissionUniquesFilters,
  type SubmissionUniquesResponse,
} from "@/api/submissions.service.js";
import { useQuery } from "./useApi.js";

type UseSubmissionUniquesOptions = {
  enabled?: boolean;
};

export function useSubmissionUniques(
  field: string,
  filters?: SubmissionUniquesFilters,
  options?: UseSubmissionUniquesOptions,
) {
  const enabled = options?.enabled ?? true;

  return useQuery<SubmissionUniquesResponse>(
    () =>
      enabled ? submissionsService.getUniques(field, filters) : Promise.resolve({ values: [] }),
    [
      enabled,
      field,
      filters?.edition,
      filters?.publicationId,
      filters?.regionId,
      filters?.editionId,
      filters?.rankingEntityId,
      filters?.bpaId,
      filters?.taxonomy,
    ],
  );
}
